import Card from "./Card";
import Image from "./Image";
import ListCardContent from "./ListCardContent";
import StatsCardContent from "./StatsCardContent";
import MapCardComponent from "./MapCardComponent";
import CrmContainer from "../sections/CrmContainer";
import StatsPopup from "../sections/StatsPopup";
import MessageContainer from "../sections/MessageContainer";

function Content() {
  return (
    <div
      className="content w-[87.5%] h-full rounded-br-3xl flex justify-center items-center"
      style={{ transformStyle: "preserve-3d" }}
    >
      <div
        className="w-[93.75%] h-[90%] flex justify-center items-center"
        style={{ transformStyle: "preserve-3d" }}
      >
        <div
          className="vessel-info absolute z-30 top-0 left-0 flex justify-center items-center w-full h-full translate-z-80"
          style={{ transformStyle: "preserve-3d" }}
        >
          <Card
            borderRadius="rounded-3xl"
            custom=" w-auto h-[95%]"
            innerContent={
              <Image
                containerCss={"rounded-3xl overflow-hidden"}
                src={
                  "https://res.cloudinary.com/dl5mqatis/image/upload/v1648327816/passage/passage-showcase/vessel-info_nvxwsq.png"
                }
              />
            }
          />
        </div>
        <div
          className="drone-card hidden w-full h-full justify-center items-center"
          style={{ transformStyle: "preserve-3d" }}
        >
          <Card
            borderRadius="rounded-3xl"
            innerContent={
              <Image
                imgCss={"rounded-3xl w-full h-full object-cover"}
                src={
                  "https://res.cloudinary.com/dl5mqatis/image/upload/v1648549844/passage/passage-showcase/drones-2048px-2x1-9431_fevtnl.jpg"
                }
              />
            }
          />
        </div>
        <div
          className="message-card w-0 h-0"
          style={{ transformStyle: "preserve-3d" }}
        >
          <MessageContainer />
        </div>
        <div
          className="crm-card w-0 h-0"
          style={{ transformStyle: "preserve-3d" }}
        >
          <Card
            borderRadius=" rounded-3xl"
            innerContent={<CrmContainer />}
          ></Card>
        </div>
        <div
          className="home-content w-full h-full flex justify-center items-center"
          style={{ transformStyle: "preserve-3d" }}
        >
          <div
            className="home-card map-card w-[60%] h-full relative"
            style={{ transformStyle: "preserve-3d" }}
          >
            <Card
              borderRadius=" rounded-3xl"
              innerContent={<MapCardComponent />}
            ></Card>
          </div>
          <div
            className="right-cards w-[40%] h-full ml-3 flex justify-center items-center flex-col"
            style={{ transformStyle: "preserve-3d" }}
          >
            <div
              className="home-card stats-card w-full h-[40%] mb-3"
              style={{ transformStyle: "preserve-3d" }}
            >
              <Card
                width="w-full"
                height="h-full"
                borderRadius=" rounded-3xl"
                innerContent={<StatsCardContent />}
              ></Card>
            </div>
            <div
              className="home-card list-card w-full h-[60%]"
              style={{ transformStyle: "preserve-3d" }}
            >
              <Card
                width="w-full"
                height="h-full"
                borderRadius=" rounded-3xl"
                innerContent={<ListCardContent />}
              ></Card>
            </div>
            <div
              className="stats-static w-full h-full top-0 absolute left-0 z-20 hidden"
              style={{ transformStyle: "preserve-3d" }}
            >
              <StatsPopup />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
